import React, { Component } from 'react';

import  './header.css';

class Header extends Component {
    render() {
        return (
            <section class="category_banner" >
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h1 id="industry_header">Loading...</h1>
                            <p id="industry_descr">Loading...</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/industry-reports/header/header.js